export const aboutData = {
  title: '关于90影院',
  subtitle: '专注8090后影视爱好者的高清在线平台',
  description: '90影院成立于2018年，是一个专为8090后打造的综合性影视在线平台。我们汇聚了海量的电影、电视剧、综艺、动漫资源，涵盖国产、港台、日韩、欧美等全球热门内容，致力于为追剧爱好者提供流畅、高清、无广告干扰的观影体验。平台每日更新最新剧集，资源库涵盖经典老片到当下热播新剧，无论你喜欢怀旧重温还是紧跟潮流，90影院都能满足你的需求。',
  stats: [
    { label: '影视资源', value: '10万+' },
    { label: '日更新量', value: '200+' },
    { label: '日均访问', value: '50万+' },
    { label: '高清覆盖率', value: '99%' },
  ],
};

export const cardsData = [
  {
    title: '庆余年 第二季',
    category: '古装剧 · 热播中',
    description: '范闲归来，京都风云再起。权谋与江湖交织，这一季的棋局更加错综复杂，张若昀领衔主演，原班人马倾情回归。',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20costume%20drama%20scene%20with%20dramatic%20lighting%2C%20royal%20palace%20interior%2C%20martial%20arts%20atmosphere%2C%20cinematic%20composition%2C%20warm%20golden%20tones%2C%20film%20poster%20style%2C%20mysterious%20and%20epic%20mood&width=900&height=410&seq=cards-01&orientation=landscape',
    tag: '热播',
    rating: '9.2',
  },
  {
    title: '抓娃娃',
    category: '喜剧片 · 高评分',
    description: '沈腾马丽再度联手，笑点密集的暑期档喜剧大片。一对富豪夫妻为教育孩子假装贫困，笑中带泪的家庭故事。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20film%20scene%20with%20warm%20family%20atmosphere%2C%20living%20room%20setting%2C%20humorous%20moment%2C%20bright%20lighting%2C%20cinematic%20shot%2C%20modern%20Chinese%20home%20interior%2C%20joyful%20and%20playful%20mood&width=600&height=375&seq=cards-02&orientation=landscape',
    tag: '新片',
    rating: '8.8',
  },
  {
    title: '玫瑰的故事',
    category: '都市剧 · 热播中',
    description: '刘亦菲演绎都市女性的成长与蜕变，一段跨越二十年的情感史诗。关于爱情、事业与自我追寻的动人故事。',
    image: 'https://readdy.ai/api/search-image?query=Modern%20urban%20Chinese%20drama%20scene%20with%20elegant%20woman%20in%20city%20setting%2C%20fashionable%20outfit%2C%20soft%20natural%20lighting%2C%20romantic%20atmosphere%2C%20cinematic%20portrait%20style%2C%20rose%20flower%20motif%2C%20warm%20and%20nostalgic%20tone&width=600&height=375&seq=cards-03&orientation=landscape',
    tag: '高分',
    rating: '9.0',
  },
  {
    title: '死侍与金刚狼',
    category: '动作片 · 新上映',
    description: '漫威年度巨制，小贱贱联手狼叔打破次元壁。史无前例的超级英雄组合，爆笑与热血齐飞的视觉盛宴。',
    image: 'https://readdy.ai/api/search-image?query=Superhero%20action%20movie%20scene%20with%20dynamic%20fighting%20pose%2C%20red%20and%20black%20costume%2C%20urban%20night%20background%2C%20explosive%20energy%2C%20cinematic%20lighting%2C%20comic%20book%20style%2C%20intense%20and%20humorous%20mood&width=600&height=375&seq=cards-04&orientation=landscape',
    tag: '热映',
    rating: '8.6',
  },
  {
    title: '唐朝诡事录之西行',
    category: '悬疑剧 · 热播中',
    description: '古装悬疑探案新篇章，卢凌风与苏无名踏上西域之旅。诡异案件、异域风情、层层反转的烧脑推理。',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20mystery%20detective%20drama%20scene%2C%20Tang%20dynasty%20setting%2C%20desert%20landscape%20with%20ancient%20architecture%2C%20mysterious%20atmosphere%2C%20cinematic%20wide%20shot%2C%20warm%20earth%20tones%2C%20suspenseful%20mood&width=600&height=375&seq=cards-05&orientation=landscape',
    tag: '热播',
    rating: '8.9',
  },
  {
    title: '鬼灭之刃 柱训练篇',
    category: '日漫 · 热播中',
    description: '炭治郎一行人接受九柱特训，为最终决战做准备。ufotable顶级作画，燃爆全场的战斗场面。',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20style%20scene%20with%20samurai%20character%20in%20training%20ground%2C%20vibrant%20water%20breathing%20effects%2C%20traditional%20Japanese%20setting%2C%20dynamic%20action%20pose%2C%20bright%20and%20saturated%20colors%2C%20epic%20cinematic%20composition&width=600&height=375&seq=cards-06&orientation=landscape',
    tag: '日漫',
    rating: '9.3',
  },
  {
    title: '歌手2024',
    category: '综艺 · 热播中',
    description: '华语乐坛顶级歌手同台竞技，全程直播无修音。实力唱将的巅峰对决，每一期都是视听盛宴。',
    image: 'https://readdy.ai/api/search-image?query=Music%20competition%20stage%20with%20dramatic%20spotlight%2C%20singer%20performing%20on%20grand%20stage%2C%20colorful%20lighting%20effects%2C%20concert%20atmosphere%2C%20professional%20show%20production%2C%20energetic%20and%20emotional%20performance&width=600&height=375&seq=cards-07&orientation=landscape',
    tag: '综艺',
    rating: '8.7',
  },
];

export const indexData = [
  { title: '古装剧场', count: '326部', icon: 'ri-sword-line', desc: '权谋、武侠、仙侠佳作汇聚' },
  { title: '悬疑推理', count: '215部', icon: 'ri-search-eye-line', desc: '烧脑案件等你来破' },
  { title: '都市情感', count: '289部', icon: 'ri-heart-line', desc: '现代都市冷暖人生' },
  { title: '科幻冒险', count: '178部', icon: 'ri-rocket-line', desc: '探索未知的想象世界' },
  { title: '喜剧专区', count: '312部', icon: 'ri-emotion-laugh-line', desc: '笑到停不下来' },
  { title: '动漫天地', count: '543部', icon: 'ri-ghost-line', desc: '日漫国漫一次看过瘾' },
  { title: '综艺热播', count: '167档', icon: 'ri-tv-line', desc: '最新综艺持续更新' },
  { title: '纪录片', count: '198部', icon: 'ri-earth-line', desc: '真实世界的精彩故事' },
  { title: '韩剧专区', count: '256部', icon: 'ri-kakao-talk-line', desc: '高分韩剧一网打尽' },
];

export const contactData = {
  title: '联系我们',
  subtitle: '资源投稿 · 意见反馈 · 商务合作',
  description: '如果你有优质的影视资源推荐、观影体验反馈或商务合作意向，欢迎通过以下方式与我们取得联系。90影院期待与你一起打造更好的观影平台。',
  email: 'contact@90cinema.com',
  wechat: 'cinema90_official',
  qq: '1234567890',
};

export const topicsData = [
  { name: '庆余年第二季', heat: '980万' },
  { name: '抓娃娃票房', heat: '856万' },
  { name: '玫瑰的故事大结局', heat: '742万' },
  { name: '死侍金刚狼彩蛋', heat: '689万' },
  { name: '唐朝诡事录解析', heat: '621万' },
  { name: '鬼灭之刃剧场版', heat: '578万' },
  { name: '歌手2024冠军预测', heat: '534万' },
  { name: '2024暑期档推荐', heat: '487万' },
  { name: '国产悬疑天花板', heat: '443万' },
  { name: '韩剧高分推荐', heat: '398万' },
  { name: '经典港片回顾', heat: '356万' },
];

export const commentsData = [
  {
    name: '追剧达人小王',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20portrait%20with%20casual%20style%2C%20friendly%20expression%2C%20clean%20white%20background%2C%20professional%20headshot%2C%20soft%20lighting&width=80&height=80&seq=avatar-01&orientation=squarish',
    date: '2024-07-28',
    content: '用了这么多影视站，90影院真的是最稳定的，高清资源更新速度一流。《庆余年2》更新的当天晚上就有高清版了，画质清晰流畅不卡顿，太赞了！推荐给所有追剧的朋友。',
    rating: 5,
  },
  {
    name: '电影爱好者老李',
    avatar: 'https://readdy.ai/api/search-image?query=Middle%20aged%20Chinese%20man%20portrait%20with%20glasses%2C%20intellectual%20look%2C%20friendly%20smile%2C%20clean%20background%2C%20professional%20headshot%2C%20warm%20lighting&width=80&height=80&seq=avatar-02&orientation=squarish',
    date: '2024-07-25',
    content: '老影迷了，平时就爱找一些经典老片回顾。90影院的片库真的很全，从港片黄金时代的经典到最新的院线大片都能找到，分类也很清晰，找片特别方便。',
    rating: 5,
  },
  {
    name: '动漫宅小陈',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20portrait%20with%20trendy%20style%2C%20bright%20smile%2C%20clean%20white%20background%2C%20professional%20headshot%2C%20soft%20natural%20lighting&width=80&height=80&seq=avatar-03&orientation=squarish',
    date: '2024-07-22',
    content: '日漫更新速度没得说，每季新番基本都能在90影院找到。《鬼灭之刃》训练篇更新的当天我就看了，画质真的绝，和B站有得一拼。国漫资源也很丰富，良心平台！',
    rating: 4,
  },
  {
    name: '综艺控阿芳',
    avatar: 'https://readdy.ai/api/search-image?query=Mature%20Chinese%20woman%20portrait%20with%20elegant%20style%2C%20gentle%20smile%2C%20clean%20background%2C%20professional%20headshot%2C%20soft%20warm%20lighting&width=80&height=80&seq=avatar-04&orientation=squarish',
    date: '2024-07-20',
    content: '周末就爱躺在沙发上看综艺，90影院综艺更新特别及时，《歌手2024》直播完没多久就能看重播了。分类做得很好，想找什么类型的综艺一目了然，体验很棒。',
    rating: 5,
  },
];

export const faqData = [
  {
    question: '90影院的影视资源是否需要付费？',
    answer: '90影院所有影视资源均免费在线观看，无需注册、无需会员、无需付费。我们致力于为广大8090后追剧爱好者提供最便捷的免费观影服务，所有内容均可直接播放。',
  },
  {
    question: '为什么有些影片播放时会出现缓冲？',
    answer: '播放缓冲通常与您的网络环境有关。90影院的服务器已针对主流宽带和移动网络进行全面优化，建议您检查本地网络连接，或尝试切换清晰度选项以获得更流畅的播放体验。',
  },
  {
    question: '平台上的影视资源多久更新一次？',
    answer: '90影院实行每日滚动更新机制，热播剧集通常在播出后2-4小时内完成更新上线。电影资源在院线下映后第一时间收录，综艺节目在直播结束后当天更新，确保您不错过任何精彩内容。',
  },
  {
    question: '如何快速找到自己想看的影片？',
    answer: '您可以使用首页顶部的搜索功能，输入影片名称或关键词即可快速定位。同时，我们的"热门推荐"和"专题合集"模块也按照类型、热度、评分等维度进行了精心整理，方便您发现更多好片。',
  },
  {
    question: '支持哪些设备观看？有APP吗？',
    answer: '90影院全面支持电脑、平板、手机等主流设备，网页端自适应适配不同屏幕尺寸。我们还提供专属APP（支持安卓和iOS），可在页面底部"APP下载"区域扫码获取，随时随地畅享高清观影。',
  },
  {
    question: '观看影片需要安装播放器或插件吗？',
    answer: '完全不需要。90影院采用先进的HTML5播放技术，主流浏览器均可直接播放，无需安装任何第三方播放器或浏览器插件。我们推荐使用Chrome、Edge或Safari等现代浏览器以获得最佳体验。',
  },
];

export const mediaData = [
  {
    title: '庆余年 第二季 终极预告',
    image: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20period%20drama%20trailer%20scene%20with%20palace%20and%20battle%20elements%2C%20dramatic%20lighting%2C%20cinematic%20widescreen%20composition%2C%20intense%20atmosphere%2C%20warm%20gold%20and%20crimson%20tones&width=600&height=340&seq=media-01&orientation=landscape',
    duration: '02:35',
    views: '1280万',
  },
  {
    title: '死侍与金刚狼 正式预告',
    image: 'https://readdy.ai/api/search-image?query=Action%20packed%20superhero%20movie%20trailer%20scene%2C%20explosive%20urban%20battle%2C%20two%20heroes%20fighting%20together%2C%20dynamic%20cinematic%20shot%2C%20dark%20city%20background%2C%20red%20and%20black%20color%20scheme&width=600&height=340&seq=media-02&orientation=landscape',
    duration: '03:12',
    views: '2150万',
  },
  {
    title: '玫瑰的故事 心动特辑',
    image: 'https://readdy.ai/api/search-image?query=Romantic%20Chinese%20drama%20scene%20with%20elegant%20woman%20walking%20through%20rose%20garden%2C%20soft%20sunlight%2C%20dreamy%20atmosphere%2C%20cinematic%20portrait%20style%2C%20warm%20pink%20and%20golden%20tones&width=600&height=340&seq=media-03&orientation=landscape',
    duration: '04:18',
    views: '890万',
  },
  {
    title: '鬼灭之刃 柱训练篇 OP',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20opening%20sequence%20style%20scene%2C%20swordsmen%20characters%20in%20dynamic%20action%2C%20vibrant%20colorful%20energy%20effects%2C%20traditional%20Japanese%20aesthetic%2C%20epic%20cinematic%20composition%2C%20high%20contrast%20lighting&width=600&height=340&seq=media-04&orientation=landscape',
    duration: '01:30',
    views: '1560万',
  },
];

export const appData = {
  title: '随时随地，畅享高清',
  subtitle: '下载90影院APP · 追剧更便捷',
  description: '支持iOS与Android双平台，流畅观影体验、离线缓存功能、个性化推荐，让你的追剧生活更加轻松自在。扫描二维码即可下载，开启随身影院。',
  features: ['高清画质流畅播放', '支持离线缓存下载', '个性化智能推荐', '片单收藏与追剧提醒'],
  iosLink: '#',
  androidLink: '#',
};

export const rankingData = [
  { rank: 1, title: '庆余年 第二季', category: '古装剧', heat: '9980' },
  { rank: 2, title: '死侍与金刚狼', category: '动作片', heat: '9620' },
  { rank: 3, title: '玫瑰的故事', category: '都市剧', heat: '9340' },
  { rank: 4, title: '唐朝诡事录之西行', category: '悬疑剧', heat: '8970' },
  { rank: 5, title: '鬼灭之刃 柱训练篇', category: '日漫', heat: '8650' },
  { rank: 6, title: '歌手2024', category: '综艺', heat: '8320' },
];

export const carouselData = [
  {
    title: '暑期档观影指南：2024不容错过的十部大片',
    image: 'https://readdy.ai/api/search-image?query=Summer%20cinema%20movie%20collage%20theme%20with%20warm%20golden%20sunset%20lighting%2C%20film%20reel%20and%20popcorn%20elements%2C%20cinematic%20widescreen%20ratio%2C%20vibrant%20and%20energetic%20atmosphere%2C%20movie%20theater%20vibes%2C%20dramatic%20composition&width=800&height=400&seq=carousel-01&orientation=landscape',
    category: '专题策划',
    description: '暑期档已至，我们为你精选了今年最值得期待的十部电影，从国产大片到好莱坞巨制，承包你的夏日观影时光。',
  },
  {
    title: '重温经典：8090后的集体影视记忆',
    image: 'https://readdy.ai/api/search-image?query=Nostalgic%20retro%20Chinese%20TV%20and%20film%20memory%20collage%2C%20vintage%20television%20set%2C%20classic%20film%20posters%20from%201980s%20and%201990s%2C%20warm%20faded%20colors%2C%20sentimental%20mood%2C%20old%20school%20aesthetic&width=800&height=400&seq=carousel-02&orientation=landscape',
    category: '怀旧专题',
    description: '那些年追过的剧、看过的片，承载了我们最珍贵的青春记忆。一起回顾属于8090后的荧幕经典。',
  },
  {
    title: '国漫崛起：从《大圣归来》到《长安三万里》',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20art%20showcase%20with%20traditional%20Chinese%20painting%20style%20mixed%20with%20modern%20animation%2C%20flowing%20ink%20effects%2C%20mythological%20creatures%2C%20vibrant%20colors%2C%20epic%20and%20artistic%20composition&width=800&height=400&seq=carousel-03&orientation=landscape',
    category: '深度专题',
    description: '从技术突破到文化自信，国漫用十年时间完成了华丽蜕变。深度盘点那些改变国产动画格局的里程碑作品。',
  },
  {
    title: '韩剧入坑指南：零基础也能找到你的那杯茶',
    image: 'https://readdy.ai/api/search-image?query=Korean%20drama%20aesthetic%20collage%20with%20romantic%20and%20dramatic%20scenes%2C%20soft%20pastel%20color%20palette%2C%20cherry%20blossom%20elements%2C%20Seoul%20cityscape%20background%2C%20cinematic%20composition%2C%20warm%20and%20dreamy%20atmosphere&width=800&height=400&seq=carousel-04&orientation=landscape',
    category: '入门指南',
    description: '还没入韩剧的坑？从悬疑到甜宠、从现实到奇幻，我们按类型为你整理了最值得一看的高分韩剧清单。',
  },
  {
    title: '悬疑片单：高智商烧脑神作一次看个够',
    image: 'https://readdy.ai/api/search-image?query=Mystery%20and%20thriller%20film%20aesthetic%20with%20dark%20investigation%20scene%2C%20magnifying%20glass%20and%20evidence%20elements%2C%20film%20noir%20style%20lighting%2C%20shadowy%20atmosphere%2C%20suspenseful%20mood%2C%20cinematic%20widescreen&width=800&height=400&seq=carousel-05&orientation=landscape',
    category: '片单推荐',
    description: '考验智商的时刻到了！精选国内外高分悬疑电影，层层反转、细思极恐，每一部都让你欲罢不能。',
  },
];

export const featuresData = [
  {
    title: '海量资源 · 每日更新',
    description: '覆盖电影、电视剧、综艺、动漫四大品类，超10万部影视资源持续扩充。实时追踪热播剧集，每日更新最新内容，让你永远站在追剧第一线。',
    icon: 'ri-database-2-line',
  },
  {
    title: '高清画质 · 流畅播放',
    description: '全站采用高清片源，支持多清晰度切换。优化的CDN加速节点覆盖全国，确保在任何网络环境下都能享受流畅无缓冲的观影体验。',
    icon: 'ri-4k-line',
  },
  {
    title: '无需注册 · 完全免费',
    description: '零门槛观影，无需注册登录，无需购买会员。打开网站即可观看全部内容，没有任何隐藏收费，真正做到让每个人都能轻松追剧。',
    icon: 'ri-vip-crown-line',
  },
];

export const updatesData = [
  {
    date: '2024-07-31',
    content: '《庆余年 第二季》全集更新完毕，36集高清版本已全部上线，含杜比音效版本。',
    tag: '剧集更新',
  },
  {
    date: '2024-07-30',
    content: '暑期档专题"国产悬疑剧天花板"上线，精选15部高分国产悬疑佳作，含独家解析。',
    tag: '专题上新',
  },
  {
    date: '2024-07-28',
    content: '平台CDN节点扩容完成，新增华南、西南两大加速节点，观影加载速度提升40%。',
    tag: '平台公告',
  },
  {
    date: '2024-07-26',
    content: '《死侍与金刚狼》高清版上线，漫威年度动作喜剧，死侍联手金刚狼打破次元壁。',
    tag: '新片上线',
  },
  {
    date: '2024-07-24',
    content: '90影院APP 3.2.0版本发布，新增离线缓存功能和个性化推荐算法优化。',
    tag: 'APP更新',
  },
  {
    date: '2024-07-22',
    content: '韩剧专区重磅扩充，《请回答1988》《信号》《鬼怪》等经典高分韩剧全部收录。',
    tag: '资源扩充',
  },
  {
    date: '2024-07-20',
    content: '周末追剧推荐专题"8090后必看的十部国产老剧"上线，勾起你的年代回忆。',
    tag: '专题上新',
  },
  {
    date: '2024-07-18',
    content: '《唐朝诡事录之西行》更新至第20集，西域探案进入白热化阶段，剧情持续高能。',
    tag: '剧集更新',
  },
];

export const siteInfo = {
  name: '90影院',
  tagline: '8090后的专属影视平台',
  footerAbout: '90影院是一个专为8090后打造的综合性免费影视在线平台，汇聚海量电影、电视剧、综艺、动漫资源，提供高清流畅的观影体验。每日更新最新热播内容，无需注册即可免费观看，是你追剧观影的最佳选择。',
};